import { apiSlice } from "../createApiSlice";

const DASHBOARD_BASE = "/dashboard";
const buildUrl = (endpoint) => DASHBOARD_BASE + endpoint;

// The totals panels above the overviews. Each subject answers a pair: what the period adds up to,
// and the same figures over time. They carry the tag of the rows they describe, so finalising an
// invoice or shipping an order refreshes the panel along with the grid under it.
const dashboardSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getInvoiceDashboardTotals: builder.query({
            query: (body) => ({
                url: buildUrl(`/invoices/totals`),
                method: 'POST',
                body: body,
            }),
            providesTags: () => [{ type: "Invoices" }],
        }),
        getInvoiceDashboardRevenue: builder.query({
            query: (body) => ({
                url: buildUrl(`/invoices/revenue`),
                method: 'POST',
                body: body,
            }),
            providesTags: () => [{ type: "Invoices" }],
        }),
        getOrderDashboardTotals: builder.query({
            query: (body) => ({
                url: buildUrl(`/orders/totals`),
                method: 'POST',
                body: body,
            }),
            providesTags: () => [{ type: "Orders" }],
        }),
        getOrderDashboardChart: builder.query({
            query: (body) => ({
                url: buildUrl(`/orders/chart`),
                method: 'POST',
                body: body,
            }),
            providesTags: () => [{ type: "Orders" }],
        }),
        getOrderRevenueDashboardTotals: builder.query({
            query: (body) => ({
                url: buildUrl(`/orders/revenue/totals`),
                method: 'POST',
                body: body,
            }),
            providesTags: () => [{ type: "Orders" }],
        }),
        getOrderRevenueDashboardChart: builder.query({
            query: (body) => ({
                url: buildUrl(`/orders/revenue/chart`),
                method: 'POST',
                body: body,
            }),
            providesTags: () => [{ type: "Orders" }],
        }),
        getInboundDashboardTotals: builder.query({
            query: (body) => ({
                url: buildUrl(`/inbounds/totals`),
                method: 'POST',
                body: body,
            }),
            providesTags: () => [{ type: "Inbounds" }],
        }),
        getInboundDashboardChart: builder.query({
            query: (body) => ({
                url: buildUrl(`/inbounds/chart`),
                method: 'POST',
                body: body,
            }),
            providesTags: () => [{ type: "Inbounds" }],
        }),
        getReturnDashboardTotals: builder.query({
            query: (body) => ({
                url: buildUrl(`/returns/totals`),
                method: 'POST',
                body: body,
            }),
            providesTags: () => [{ type: "Returns" }],
        }),
        getReturnDashboardChart: builder.query({
            query: (body) => ({
                url: buildUrl(`/returns/chart`),
                method: 'POST',
                body: body,
            }),
            providesTags: () => [{ type: "Returns" }],
        }),
        getShipmentDashboardTotals: builder.query({
            query: (body) => ({
                url: buildUrl(`/shipments/totals`),
                method: 'POST',
                body: body,
            }),
            providesTags: () => [{ type: "Shipments" }],
        }),
        getShipmentDashboardChart: builder.query({
            query: (body) => ({
                url: buildUrl(`/shipments/chart`),
                method: 'POST',
                body: body,
            }),
            providesTags: () => [{ type: "Shipments" }],
        }),
    })
});

export const {
    useGetInvoiceDashboardTotalsQuery,
    useGetInvoiceDashboardRevenueQuery,
    useGetOrderDashboardTotalsQuery,
    useGetOrderDashboardChartQuery,
    useGetOrderRevenueDashboardTotalsQuery,
    useGetOrderRevenueDashboardChartQuery,
    useGetInboundDashboardTotalsQuery,
    useGetInboundDashboardChartQuery,
    useGetReturnDashboardTotalsQuery,
    useGetReturnDashboardChartQuery,
    useGetShipmentDashboardTotalsQuery,
    useGetShipmentDashboardChartQuery,
} = dashboardSlice;
